const { default: React } = require("react");
const { useLocation, useParams, useNavigate } = require("react-router-dom");

//Higher order Component so we can access Router parameters as Router v6 parames do not support class component and only support React hooks
export default function withRouter(Component) {
    return props => <Component {...props} routerLocation={useLocation()} routerParams={useParams()} routerNavigate={useNavigate()} />;
};
